import pkg from "../../package.json";
import "./version.scss";
const Version = () => {
  return <div className="system_version">{pkg.version}</div>;
};

export default Version;
